import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {manager} from 'ag-common/tools/ausbildungsplan/table'
import QuestionDescription from './QuestionDescription'
import {withAnswer} from '#components/HOC/withAnswerHOC'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'
import Input from '#components/a/form/Input'

export class QuestionTable extends React.Component {
  onChangeText = (tableIndex, row, col, text) => {
    this.props.setHasUnsavedChanges(true)
    const updatedAnswer = manager(this.props.currentAnswer).setAnswer(tableIndex, row, col, text)
    this.props.updateAnswer(updatedAnswer)
  }

  onBlur = async () => {
    await this.props.saveAnswer()
    this.props.setHasUnsavedChanges(false)
  }

  getAnswerForRowAndColumn(tableIndex, row, col) {
    return manager(this.props.currentAnswer).getAnswer(tableIndex, row, col)
  }

  renderTable = ({columnLabels, rowLabels, contentColumnCount, contentRowCount, prefilledAnswers}, tableIndex) => {
    const hasRowLabels = rowLabels && rowLabels.length > 0
    return (
      <div className="question-table" key={tableIndex.toString()}>
        <div className="question-table__header">
          {this.renderHeader(columnLabels, contentColumnCount, hasRowLabels)}
        </div>
        <div className="question-table__body">
          {this.renderRows(tableIndex, contentRowCount, contentColumnCount, prefilledAnswers, rowLabels)}
        </div>
      </div>
    )
  }

  // eslint-disable-next-line class-methods-use-this
  renderHeader(columnLabels, contentColumnCount, hasRowLabels) {
    const headerColumns = []
    if (hasRowLabels) {
      headerColumns.push(<div className="question-table__header-col-label" key="header-col-label" />)
    }
    for (let i = 0; i < contentColumnCount; i++) {
      headerColumns.push(
        <div className="question-table__header-col" key={`header-col-${i}`}>
          <Headline importance={2} modifier="fragment" text={columnLabels[i]} />
        </div>,
      )
    }
    return headerColumns
  }

  renderRows(tableIndex, contentRowCount, contentColumnCount, prefilledAnswers, rowLabels) {
    const rows = []
    for (let i = 0; i < contentRowCount; i++) {
      rows.push(
        <div className="question-table__body-row" key={`body-row-${i}`}>
          {this.renderRow(tableIndex, i, contentColumnCount, prefilledAnswers, rowLabels)}
        </div>,
      )
    }
    return rows
  }

  renderRow(tableIndex, row, contentColumnCount, prefilledAnswers, rowLabels) {
    const hasRowLabels = rowLabels && rowLabels.length > 0
    const cols = []
    if (hasRowLabels) {
      cols.push(
        <div key={`row-${row}-col---1`} className="question-table__body-row-label">
          <Headline importance={3} modifier="fragment" text={rowLabels[row]} />
        </div>,
      )
    }
    for (let i = 0; i < contentColumnCount; i++) {
      const key = `body-row-${row}-col-${i}`
      const prefilledAnswer = prefilledAnswers.find(x => x.row === row && x.column === i)
      cols.push(
        <div className="question-table__body-row-answer" key={key}>
          {prefilledAnswer ? (
            <Text modifier="copy" text={prefilledAnswer.text} />
          ) : (
            this.renderAnswer(tableIndex, row, i)
          )}
        </div>,
      )
    }
    return cols
  }

  renderAnswer(tableIndex, row, i) {
    const answer = this.getAnswerForRowAndColumn(tableIndex, row, i)
    return this.props.isReadOnly && answer ? (
      <Text text={answer} />
    ) : (
      <Input
        onChangeHandle={e => this.onChangeText(tableIndex, row, i, e.target.value)}
        value={this.getAnswerForRowAndColumn(tableIndex, row, i)}
        onBlurHandle={this.onBlur}
        isDisabled={this.props.isReadOnly}
      />
    )
  }

  render() {
    const {question} = this.props
    return (
      <>
        {this.props.children}
        <QuestionDescription question={question} />
        <div className="question-table-wrapper">{question.content.map(this.renderTable)}</div>
      </>
    )
  }
}

QuestionTable.propTypes = {
  updateAnswer: PropTypes.func.isRequired,
  saveAnswer: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  currentAnswer: PropTypes.object,
  question: PropTypes.object,
  setHasUnsavedChanges: PropTypes.func.isRequired,
  children: PropTypes.node,
}

export default withAnswer(QuestionTable)
